import { useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import Context from '../../../store/context';
import { getApiErrorMessage } from '../../../store/constants/apiErrorMessage';
import { paths } from '../../../routes';

export const useGlobalErrorHandler = () => {
    const { toast } = useContext(Context);
    const navigate = useNavigate();

    useEffect(() => {
        const handleError = (error) => {
            const errorMessage = getApiErrorMessage(error);

            // Mostrar el mensaje de error usando el sistema de toast
            toast.showError(errorMessage);

            // Manejar errores específicos
            if (error.response) {
                switch (error.response.status) {
                    case 401:
                        // Redirigir al login si la sesión expiró
                        navigate(paths.login);
                        break;
                    case 403:
                        // Redirigir a una página de acceso denegado
                        navigate(paths.forbidden);
                        break;
                    default:
                        break;
                }
            }
        };

        // Agregar el manejador de errores global
        window.addEventListener('unhandledrejection', (event) => {
            handleError(event.reason);
        });

        // Limpiar el manejador cuando el componente se desmonte
        return () => {
            window.removeEventListener('unhandledrejection', handleError);
        };
    }, [toast, navigate]);
};